

















































































import { Vue, Component } from 'vue-property-decorator'
import Engine from './Engine'

@Component
export default class Table extends Vue {
  private localPaddleYPercent = 50
  private remotePaddleYPercent = 50
  private paddleHeightPercent = 20
  private paddleWidthPercent = 1
  private paddleSpacePercent = 1

  public ballXPercent = 50
  public ballYPercent = 50
  public ballXStepPercent = 1
  public ballYStepPercent = 0

  public countdown = 0
  public time = 0
  public level = 0

  private ballWidthPercent = 1
  private ballHeightPercent = 1
  private ballStepMillis = 20

  private aspectRatioWidth = 16
  private aspectRatioHeight = 9

  private engine: Engine

  private get tableStyle(): Object {
    // max level is 30, so this works out to a max of 60% * 255
    let red = (this.level / 50) * 255
    return {
      backgroundColor: 'rgb(' + red + ', 0, 0)'
    }
  }

  public constructor() {
    super()

    // square off the 'ball'
    if (this.aspectRatioWidth > this.aspectRatioHeight) {
      this.ballHeightPercent = (this.aspectRatioWidth / this.aspectRatioHeight)
    } else {
      this.ballWidthPercent = (this.aspectRatioHeight / this.aspectRatioWidth)
    }

    this.engine = new Engine(60)
    this.engine.addOnUpdate(this.update)
  }
  
  private created(): void {
    window.addEventListener('keydown', this.onKeyPress)
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('touchmove', this.onTouchMove)
  }

  private destroyed(): void {
    window.removeEventListener('touchmove', this.onTouchMove)
    window.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('keydown', this.onKeyPress)
  }

  private beforeDestroy(): void {
    if (this.engine) {
      this.engine.stop()
    }
  }

  public start(): boolean {
    this.countdown = 3000
    this.engine.start()
    return true
  }
  public stop(): boolean {
    this.engine.stop()
    this.countdown = 0
    return true
  }

  private get container(): HTMLElement {
    return this.$refs.container as HTMLElement
  }
  private get localPaddle(): HTMLElement {
    return this.$refs.localPaddle as HTMLElement
  }
  private get remotePaddle(): HTMLElement {
    return this.$refs.remotePaddle as HTMLElement
  }
  private get ball(): HTMLElement {
    return this.$refs.ball as HTMLElement
  }

  private get localPaddleYLowerPercent(): number {
    return this.localPaddleYPercent - (this.paddleHeightPercent / 2)
  }
  private get localPaddleYUpperPercent(): number {
    return this.localPaddleYPercent + (this.paddleHeightPercent / 2)
  }
  private get remotePaddleYLowerPercent(): number {
    return this.remotePaddleYPercent - (this.paddleHeightPercent / 2)
  }
  private get remotePaddleYUpperPercent(): number {
    return this.remotePaddleYPercent + (this.paddleHeightPercent / 2)
  }

  private get aspectRatio(): number {
    return this.aspectRatioWidth / this.aspectRatioHeight
  }
  private get localPaddleStyle(): Object {
    return {
      top: (this.localPaddleYPercent - (this.paddleHeightPercent / 2)) + '%',
      left: this.paddleSpacePercent + '%',
      width: this.paddleWidthPercent + '%',
      height: this.paddleHeightPercent + '%',
    }
  }
  private get remotePaddleStyle(): Object {
    return {
      top: (this.remotePaddleYPercent - (this.paddleHeightPercent / 2)) + '%',
      right: this.paddleSpacePercent + '%',
      width: this.paddleWidthPercent + '%',
      height: this.paddleHeightPercent + '%',
    }
  }
  private get ballStyle(): Object {
    return { 
      top: (this.ballYPercent - (this.ballHeightPercent / 2)) + '%',
      left: (this.ballXPercent - (this.ballWidthPercent / 2)) + '%',
      width: this.ballWidthPercent + '%',
      height: this.ballHeightPercent + '%',
    }
  }

  private onTouchMove(event: TouchEvent): void {
    this.moveLocalPaddle(event.touches[0].clientY)
  }

  private onMouseMove(event: MouseEvent): void {
    this.moveLocalPaddle(event.clientY)
  }

  private moveLocalPaddle(windowY: number) {
    let offsetY = windowY - this.container.getBoundingClientRect().top
    let tableHeightPixels = this.container.clientHeight
    let paddleHalfHeightPixels = this.localPaddle.offsetHeight / 2
    let normalizedYPixels = Math.max(paddleHalfHeightPixels, Math.min(tableHeightPixels - paddleHalfHeightPixels, offsetY))
    this.localPaddleYPercent = 100 * normalizedYPixels / tableHeightPixels

    // event
    this.$emit('localPaddleMove', this.localPaddleYPercent)
  }

  private onKeyPress(event: KeyboardEvent): void {
    if (event.which == 38) { // up
      let minPercent = this.paddleHeightPercent / 2
      if (event.metaKey) {
        this.localPaddleYPercent = minPercent
      } else {
        let offset = event.altKey ? this.paddleHeightPercent : 5
        this.localPaddleYPercent = Math.max(minPercent, this.localPaddleYPercent - offset)
      }

      // event
      this.$emit('localPaddleMove', this.localPaddleYPercent)
    } else if (event.which == 40) { // down
      let maxPercent = 100 - this.paddleHeightPercent / 2;
      if (event.metaKey) {
        this.localPaddleYPercent = maxPercent
      } else {
        let offset = event.altKey ? this.paddleHeightPercent : 5
        this.localPaddleYPercent = Math.min(maxPercent, this.localPaddleYPercent + offset)
      }

      // event
      this.$emit('localPaddleMove', this.localPaddleYPercent)
    }
  }

  private get topEdgePercent(): number {
    return 0
  }
  private get bottomEdgePercent(): number {
    return 100
  }
  private get leftTableEdgePercent(): number {
    return 0
  }
  private get rightTableEdgePercent(): number {
    return 100
  }
  private get leftPaddleEdgePercent(): number {
    return this.paddleSpacePercent + this.paddleWidthPercent
  }
  private get rightPaddleEdgePercent(): number {
    return 100 - this.paddleSpacePercent - this.paddleWidthPercent
  }

  private get overshootTableY(): number {
    return this.ballYPercent - this.bottomEdgePercent
  }
  private get undershootTableY(): number {
    return this.topEdgePercent - this.ballYPercent
  }
  private get overshootTableX(): number {
    return this.ballXPercent - this.rightTableEdgePercent
  }
  private get undershootTableX(): number {
    return this.leftTableEdgePercent - this.ballXPercent
  }
  private get overshootPaddleX(): number {
    return this.ballXPercent - this.rightPaddleEdgePercent
  }
  private get undershootPaddleX(): number {
    return this.leftPaddleEdgePercent - this.ballXPercent
  }

  private update(): void {
    let frameMillis = this.engine.getFrameMillis()
    this.time += frameMillis
    this.level = Math.min(30, Math.floor(this.time / 30000))

    // after 30 mins we are at max of 60% faster ball / 60% smaller paddle
    let multiplier = this.level * 2 / 100
    let speed = 1 + multiplier
    this.paddleHeightPercent = 20 * (1 - multiplier)

    if (this.countdown > 0) {
      let oldCountdown = this.countdown
      let newCountdown = oldCountdown - frameMillis
      if (newCountdown < 0) {
        newCountdown = 0
      }

      this.countdown = newCountdown
      
      let newCountdownSecond = Math.ceil(newCountdown / 1000)
      let oldCountdownSecond = Math.ceil(oldCountdown / 1000)
      if (newCountdownSecond != oldCountdownSecond) {
        this.$emit('countdownChange', newCountdownSecond, oldCountdownSecond)
      }
      return
    }

    let frameRateNormalizer = frameMillis / this.ballStepMillis

    let ballXStepPercent = this.ballXStepPercent * frameRateNormalizer * speed
    let ballYStepPercent = this.ballYStepPercent * frameRateNormalizer * speed

    // update ball position
    this.ballXPercent = this.ballXPercent + ballXStepPercent
    this.ballYPercent = this.ballYPercent + ballYStepPercent

    // if we are still on the table
    if (this.overshootTableX < 0 && this.undershootTableX < 0){

      // bounce off the bottom
      if (this.overshootTableY >= 0) {

        // update Y position
        this.ballYPercent -= this.overshootTableY
        this.ballYStepPercent = -this.ballYStepPercent

        // event
        this.$emit('bottomBounce')
      }

      // bounce off the top
      if (this.undershootTableY >= 0) {

        // update Y position
        this.ballYPercent += this.undershootTableY
        this.ballYStepPercent = -this.ballYStepPercent

        // event
        this.$emit('topBounce')
      }
    }

    // remote hit?
    if (this.overshootPaddleX >= 0) {
      if (this.ballYPercent >= this.remotePaddleYLowerPercent && this.ballYPercent <= this.remotePaddleYUpperPercent) {

        // update X position (guess, will be corrected by peer)
        this.ballXPercent -= this.overshootPaddleX
        this.ballXStepPercent = -this.ballXStepPercent

        // update Y position (guess, will be corrected by peer)
        this.ballYStepPercent -= (this.remotePaddleYPercent - this.ballYPercent) / this.paddleHeightPercent
      }
    }

    // local hit?
    if (this.undershootPaddleX >= 0) {
      if (this.ballYPercent >= this.localPaddleYLowerPercent && this.ballYPercent <= this.localPaddleYUpperPercent) {

        // update X position
        this.ballXPercent += this.undershootPaddleX
        this.ballXStepPercent = -this.ballXStepPercent

        // update Y position
        this.ballYStepPercent -= (this.localPaddleYPercent - this.ballYPercent) / this.paddleHeightPercent

        // event
        this.$emit('localHit')
      }
    }

    // local miss?
    if (this.undershootTableX >= 0) {
      this.ballXPercent += this.undershootPaddleX

      // reset countdown
      this.countdown = 3000

      // reset ball
      this.ballXPercent = 50
      this.ballYPercent = 50

      // randomize Y in -1/+1 exclusive
      let random = Math.random()
      if (Math.random() < 0.5) {
        random = -random
      }
      this.ballYStepPercent = random

      // event
      this.$emit('localMiss')
    }
  }

  public remoteDisconnect(): void {
    this.remotePaddleYPercent = 50
  }
  public setRemotePaddleYPercent(remotePaddleYPercent: number): void {
    this.remotePaddleYPercent = remotePaddleYPercent
  }
}
